<div class="header">
    <div class="row">
        <div class="col-6">
            <h2>Compilazione <strong>Pratica</strong></h2>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/dashboard']">Pratiche</a></li>
                <li class="active">Compilazione Pratica</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-10 portlets" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div *ngIf="request.IDRequest !== undefined" class="session-valid">
                    <div class="row" style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <form role="form" class="form-horizontal form-validation">
                                <div *ngIf="user.FKIDUserRole === 2" class="form-group">
                                    <label for="tax-credit-4-goods" class="col-sm-12 control-label">
                                        Indicare i beni materiali e immateriali nuovi, strumentali all’esercizio
                                        d’impresa con la denominazione prevista dagli allegati A e B annessi alla legge
                                        11 dicembre 2016, n. 232, in base all'offerta caricata dal cliente
                                    </label>
                                    <div class="col-sm-12 prepend-icon m-t-10">
                                        <input type="number"
                                               id="tax-credit-4-goods"
                                               name="tax-credit-4-goods"
                                               class="form-control"
                                               placeholder="Indica i beni materiali e immateriali"
                                               step="1"
                                               min="10"
                                               max="999"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4Goods.valid || taxCredit4Goods.pristine),
                                                'form-success': taxCredit4Goods.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4Goods"
                                               #taxCredit4Goods="ngModel">
                                        <i class="icon-wallet"></i>
                                        <div [hidden]="taxCredit4Goods.valid || taxCredit4Goods.pristine"
                                             class="form-error valid">
                                            Il numero di beni deve essere di 2 o 3 cifre.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="user.FKIDUserRole === 3" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Interventi trainati 5.0
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInterventionsValues[0]"
                                                      (change)="valueChangeInterventions(0)">
                                            {{ checkboxInterventionsOptions[0] }}
                                        </mat-checkbox>
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInterventionsValues[1]"
                                                      (change)="valueChangeInterventions(1)">
                                            {{ checkboxInterventionsOptions[1] }}
                                        </mat-checkbox>
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInterventionsValues[2]"
                                                      (change)="valueChangeInterventions(2)">
                                            {{ checkboxInterventionsOptions[2] }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                                <div *ngIf="user.FKIDUserRole === 3" class="form-group">
                                    <label for="tax-credit-5-energy-consumption" class="col-sm-3 control-label">
                                        Indicare la riduzione dei consumi energetici stimata (TEP/ANNO)
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-20">
                                        <input type="text"
                                               id="tax-credit-5-energy-consumption"
                                               name="tax-credit-5-energy-consumption"
                                               class="form-control"
                                               placeholder="Indica la riduzione dei consumi energetici stimata"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5EnergyConsumption.valid || taxCredit5EnergyConsumption.pristine),
                                                'form-success': taxCredit5EnergyConsumption.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5EnergyConsumption"
                                               #taxCredit5EnergyConsumption="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5EnergyConsumption.valid || taxCredit5EnergyConsumption.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="user.FKIDUserRole === 3" class="form-group">
                                    <label for="tax-credit-5-savings" class="col-sm-3 control-label">
                                        Indicare la percentuale stimata di risparmio annuo
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="text"
                                               id="tax-credit-5-savings"
                                               name="tax-credit-5-savings"
                                               class="form-control"
                                               placeholder="Indica la percentuale stimata di risparmio annuo"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Savings.valid || taxCredit5Savings.pristine),
                                                'form-success': taxCredit5Savings.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5Savings"
                                               #taxCredit5Savings="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Savings.valid || taxCredit5Savings.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>
                                <hr *ngIf="user.FKIDUserRole === 3" style="margin-top: 30px; margin-bottom: 0;">
                                <div *ngIf="user.FKIDUserRole === 3" class="form-group">
                                    <label class="col-12 control-label m-b-20">Dati Certificatore</label>
                                    <label for="tax-credit-5-certifier-name" class="col-sm-3 control-label">
                                        Nome
                                    </label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-certifier-name"
                                               name="tax-credit-5-certifier-name"
                                               class="form-control"
                                               placeholder="Inserisci il nome del certificatore"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Name.valid || taxCredit5Name.pristine),
                                                'form-success': taxCredit5Name.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CertifierName"
                                               #taxCredit5Name="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Name.valid || taxCredit5Name.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="user.FKIDUserRole === 3" class="form-group">
                                    <label for="tax-credit-5-certifier-name" class="col-sm-3 control-label">
                                        Cognome
                                    </label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-certifier-surname"
                                               name="tax-credit-5-certifier-surname"
                                               class="form-control"
                                               placeholder="Inserisci il cognome del certificatore"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Surname.valid || taxCredit5Surname.pristine),
                                                'form-success': taxCredit5Surname.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CertifierSurname"
                                               #taxCredit5Surname="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Surname.valid || taxCredit5Surname.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="user.FKIDUserRole === 3" class="form-group">
                                    <label for="tax-credit-5-cf" class="col-sm-3 control-label">
                                        Codice Fiscale
                                    </label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-cf"
                                               name="tax-credit-5-cf"
                                               class="form-control"
                                               placeholder="Inserisci il codice fiscale del certificatore"
                                               minlength="11"
                                               maxlength="16"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5CF.valid || taxCredit5CF.pristine),
                                                'form-success': taxCredit5CF.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CertifierCF"
                                               #taxCredit5CF="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5CF.valid || taxCredit5CF.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 11 caratteri e massimo 16.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="user.FKIDUserRole === 3" class="form-group">
                                    <label for="tax-credit-5-certifier-code" class="col-sm-3 control-label">
                                        Codice certificazione e organismo di certificazione
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="text"
                                               id="tax-credit-5-certifier-code"
                                               name="tax-credit-5-certifier-code"
                                               class="form-control"
                                               placeholder="Inserisci il codice certificazione"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Code.valid || taxCredit5Code.pristine),
                                                'form-success': taxCredit5Code.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CertifierCode"
                                               #taxCredit5Code="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Code.valid || taxCredit5Code.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div *ngIf="user.FKIDUserRole === 2 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12" style="font-weight: bold;">Carta di Identità del firmatario
                                    della Perizia 4.0
                                </div>
                                <div class="col-9 input-group mb-3 mt-4">
                                    <div class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-4-id-card"
                                               name="tax-credit-4-id-card"
                                               (change)="uploadDocument($event, 12)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-4-id-card">{{ fileName[12] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['12']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 2 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Perizia 4.0</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['11'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-4-expertise"
                                               name="tax-credit-4-expertise"
                                               (change)="uploadDocument($event, 11)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-4-expertise">{{ fileName[11] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['11'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['11']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 2 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Assicurazione professionale</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['19'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-offer-4"
                                               name="tax-credit-5-offer-4"
                                               (change)="uploadDocument($event, 19)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-offer-4">{{ fileName[19] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['19'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['19']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 2 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Fatture</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-invoice-4"
                                               name="tax-credit-5-invoice-4"
                                               (change)="uploadDocument($event, 20)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-invoice-4">{{ fileName[20] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['20'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['20']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <hr *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber"
                                style="margin-top: 30px; margin-bottom: 30px;">
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Carta di Identità del
                                    firmatario della Certificazione ex ante
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['14'].length === 0" class="custom-file m-b-12 m-t-20">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-id-card"
                                               name="tax-credit-5-id-card"
                                               (change)="uploadDocument($event, 14)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-id-card">{{ fileName[14] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['14'].length > 0" class="width-100p m-t-20">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['14']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Certificazione ex ante 5.0
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['13'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-certification-ante"
                                               name="tax-credit-5-certification-ante"
                                               (change)="uploadDocument($event, 13)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-certification-ante">{{ fileName[13] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['13'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['13']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Modulo di certificazione Esco/Ege
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['23'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-esco-ege"
                                               name="tax-credit-5-esco-ege"
                                               (change)="uploadDocument($event, 23)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-esco-ege">{{ fileName[23] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['23'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['23']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Dichiarazione di terzietà
                                    del valutatore indipendente
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['24'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-third-party"
                                               name="tax-credit-5-third-party"
                                               (change)="uploadDocument($event, 24)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-third-party">{{ fileName[24] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['24'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['24']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">
                                    Documentazione relativa alla sicurezza sul luogo di lavoro, quali il “Documento di
                                    Valutazione dei Rischi” (DVR) e altri eventuali documenti di interesse
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['18'].length === 0" class="custom-file m-b-12 m-t-40">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-work-safety"
                                               name="tax-credit-5-work-safety"
                                               (change)="uploadDocument($event, 18)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-work-safety">{{ fileName[18] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['18'].length > 0" class="width-100p m-t-10 m-t-40">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['18']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Assicurazione professionale</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['21'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-offer-5"
                                               name="tax-credit-5-offer-5"
                                               (change)="uploadDocument($event, 21)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-offer-5">{{ fileName[21] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['21'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['21']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 3 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Fatture</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-invoice-5"
                                               name="tax-credit-5-invoice-5"
                                               (change)="uploadDocument($event, 22)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-invoice-5">{{ fileName[22] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['22'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['22']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- Revisore Legale dei Conti -->
                            <div *ngIf="user.FKIDUserRole === 4 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Carta di Identità del
                                    firmatario della Certificazione contabile
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['25'].length === 0" class="custom-file m-b-12 m-t-20">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-id-card-counting"
                                               name="tax-credit-5-id-card-counting"
                                               (change)="uploadDocument($event, 25)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-id-card-counting">{{ fileName[25] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['25'].length > 0" class="width-100p m-t-20">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['25']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 4 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Certificazione contabile
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['26'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-certification-counting"
                                               name="tax-credit-5-certification-counting"
                                               (change)="uploadDocument($event, 26)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-certification-counting">{{ fileName[26] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['26'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['26']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 4 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Fattura di acquisto del bene
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['27'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-purchase-invoice"
                                               name="tax-credit-5-purchase-invoice"
                                               (change)="uploadDocument($event, 27)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-purchase-invoice">{{ fileName[27] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['27'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['27']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="user.FKIDUserRole === 4 && request.customer?.VATNumber" class="row m-b-10">
                                <div class="col-3 m-t-12 mb-20" style="font-weight: bold;">Contratto di leasing
                                    (se previsto)
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['28'].length === 0" class="custom-file m-b-12 m-t-5">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="tax-credit-5-leasing-contract"
                                               name="tax-credit-5-leasing-contract"
                                               (change)="uploadDocument($event, 28)"
                                               required>
                                        <label class="custom-file-label"
                                               for="tax-credit-5-leasing-contract">{{ fileName[28] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['28'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['28']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-primary"
                                        (click)="saveRequest()">
                                    <i class="fa fa-floppy-o"></i>Salva
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="request.IDRequest === undefined" class="session-invalid">
                    Impossibile recuperare la pratica
                </div>
            </div>
        </div>
    </div>
</div>
